import { gql, useMutation } from '@apollo/client';

import { BillProjectHoursRequestFilter } from '@work4all/models/lib/Classes/BillProjectHoursRequestFilter.entity';
import { BillProjectHoursRequestSettings } from '@work4all/models/lib/Classes/BillProjectHoursRequestSettings.entity';
import { BillProjectHoursResult } from '@work4all/models/lib/Classes/BillProjectHoursResult.entity';

const MUTATION = gql`
  mutation BillProjectHours(
    $filters: BillProjectHoursRequestFilter!
    $settings: BillProjectHoursRequestSettings!
  ) {
    billProjectHours(filters: $filters, settings: $settings) {
      createdBzObjectCodes
      errors {
        apiValidationErrorType
        data
        property
        validationDataType
      }
    }
  }
`;

type MutationResponse = BillProjectHoursResult;

type MutationVars = {
  filters: BillProjectHoursRequestFilter;
  settings: BillProjectHoursRequestSettings;
};

export const useBillProjectHours = () => {
  return useMutation<{ billProjectHours: MutationResponse }, MutationVars>(
    MUTATION
  );
};
